export const getCurrentFiltersCount =
    <RenderState extends Record<string, Maybe<{ currentRefinements: {items: object[]} }>>>(
    indexName: string,
    renderState: RenderState,
  ): number => {

      return renderState[indexName]?.currentRefinements?.items?.length || 0;
    
    };
